import React, {useEffect, useState} from "react";
import {makeStyles, TextField} from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Search from "@material-ui/icons/Search";
import clsx from "clsx";
import {useSelector} from "react-redux";
import {debounce} from "lodash";
import request from "../../../../../../../../Services/API/Requests";
import {multiLanguageValue} from "../../../../../../../JsonScreen/Utils/lib";

const useStyles = makeStyles(() => ({
    list: {
        listStyle: 'none',
        padding: '0 15px',
    },
    listItem: {
        cursor: 'pointer',
        margin: '3px 0'
    },
    listItemSelected: {
        fontWeight: 'bold'
    }
}))
const CategoryList = ({selectedFilter, setSelectedFilter, textFilter, setTextFilter}) => {
    const classes = useStyles();
    const userLanguage = useSelector(state => state.app.userLanguage);
    const [data, setData] = useState([]);

    useEffect(() => {
        request({
            url: "/dataSource/getData",
            data: {
                id: 'screenTemplateGroupDefaultList'
            }
        }).then(res => {
            setData(res.content)
        }).catch(err => {
            console.log('get categories error', err)
        })
    }, []);

    const onChangeFilter = debounce((e) => {
        setTextFilter(e.target.value)
    }, 300)

    return (
        <div style={{width: '30%'}}>
            <div style={{
                padding: '15px 10px 0 10px',
            }}>
                <TextField variant={"outlined"} size={'small'}
                           placeholder={'search...'}
                           value={textFilter}
                           onChange={onChangeFilter}
                           InputProps={{
                               style: {padding: '0 0 0 5px', borderRadius: 35},
                               startAdornment: (
                                   <InputAdornment position="start">
                                       <IconButton
                                           size={'small'}
                                           aria-label="search menu items"
                                       >
                                           <Search/>
                                       </IconButton>
                                   </InputAdornment>)
                           }}
                />
            </div>

            <ul style={{listStyle: "none", padding: '0 15px'}}>
                <li
                    onClick={() => setSelectedFilter(undefined)}
                    className={clsx(classes.listItem, {[classes.listItemSelected]: !selectedFilter})}
                >
                    All
                </li>
                {data.map(item => {
                    return (
                        <li
                            onClick={() => setSelectedFilter(item.id || item._id)}
                            className={clsx(classes.listItem, {[classes.listItemSelected]: selectedFilter === (item.id || item._id)})}
                        >
                            {multiLanguageValue(item.name, userLanguage)}
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}

export default CategoryList;